import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'

//system
import User from './views/system/User.vue'
import WechatUser from './views/system/WechatUser.vue'
import ScriptMng from './views/system/ScriptMng.vue'

Vue.use(Router)

const dynamicRoutes = [{
	path: '/',
	component: Home,
	name: '系统管理',
	iconCls: require("./assets/icon/system.png"), //图标样式class
	hidden: false,
	roleid: 'system',
	children: [{
			path: '/user',
			component: User,
			name: '用户管理',
			hidden: false,
			roleid: 'system.permission'
		},
		{
			path: '/WechatUser',
			component: WechatUser,
			name: '微信用户',
			hidden: false,
			roleid: 'system.wxuser'
		},
		{
			path: '/ScriptMng',
			component: ScriptMng,
			name: '脚本管理',
			hidden: false,
			roleid: 'system.scriptmng'
		},
	]
}]

const staticRoutes = [{
		path: '/login',
		component: Login,
		name: '',
		hidden: true
	},
	{
		path: '/404',
		component: NotFound,
		name: '',
		hidden: true
	}
]

const RoutesTable = staticRoutes
export {
	dynamicRoutes
}

export default new Router({
	routes: RoutesTable
})